import React from "react";
import { theme, Tooltip, Modal } from 'antd';
import {
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import ColorButton from "./ColorButton";

export default function CustomDeleteConfirmButton(props) {
  const { token : { colorError }} = theme.useToken();

  const confirm = () => {
    Modal.confirm({
      title: props.title ? props.title :"ลบรายการ",
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: props.content ? props.content : "ยืนยันลบรายการนี้หรือไม่ ?",
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk: props.onOk,
      onConfirm: props.onConfirm,
    });
  };

  return (
    <Tooltip triger='hover' title={ props.tooltips ? props.tooltips : "ลบข้อมูล" }>
    <ColorButton 
      type='primary'
      override={props.override ? props.override : colorError }
      icon={props.icon ? props.icon : <DeleteOutlined />}
      style={{ margin : 5}}
      onClick={()=> confirm()} 
      disabled={props.disabled}
    />
  </Tooltip>
  )
}